const baseQueryParams = {
  publicationState: 'live',
  pagination: {
    page: 1,
    pageSize: 25,
  },
};

export const streamQueryParams = {
  ...baseQueryParams,
  sort: 'filter_sequence:asc',
  fields: ['stream_name', 'filter_sequence'],
};

export const courseQueryParams = {
  ...baseQueryParams,
  sort: ['display_sequence:asc'],
  fields: ['abbreviation', 'course_name', 'course_url', 'is_top'],
  pagination: { ...baseQueryParams.pagination, pageSize: 50 },
  populate: {
    page_data: {
      fields: ['id'],
    },
  },
};

export const countryQueryParams = {
  ...baseQueryParams,
  sort: ['display_sequence:asc'],
  fields: ['abbreviation', 'country_name', 'country_url', 'is_top'],
  populate: {
    flags: {
      fields: ['url', 'name'],
    },
  },
  filters: {
    colleges: {
      id: {
        $notNull: true,
      },
    },
  },
};

export const stateQueryParams = {
  ...baseQueryParams,
  fields: ['state_name', 'is_top', 'top_display_sequence', 'state_url'],
  filters: {
    country: {
      country_name: { $eqi: 'India' },
    },
  },
  populate: { cities: { fields: ['city_name'] } },
  pagination: { ...baseQueryParams.pagination, pageSize: 40 },
};

export const citiesQueryParams = {
  ...baseQueryParams,
  fields: ['city_name', 'city_url'],
  filters: {
    is_top: { $eq: true },
    geo_country: {
      country_name: { $eqi: 'India' },
    },
  },
};

export const collegesQueryParams = {
  ...baseQueryParams,
  sort: 'display_sequence:asc',
  filters: {
    // is_top: { $eq: true },
    country: { country_name: { $ne: 'India' } },
  },
  fields: ['college_name', 'college_url', 'abbreviation', 'average_placement', 'is_top'],
  populate: {
    college_navbars: { fields: ['id', 'title'] },
    logo: { fields: ['id', 'url', 'name'] },
    streams: { fields: ['id', 'stream_name'] },
    country: { fields: ['id', 'country_name', 'country_url'] },
    banner: { fields: ['id', 'url', 'name'] },
    city: { fields: ['id', 'city_name'] },
    state: { fields: ['id', 'state_name'] },
    download_brochure: {
      fields: ['id', 'url', 'name'],
    },
    approved_by: { fields: ['organisation_name'] },
    companies: { fields: ['abbreviation', 'name'] },
  },
};

export const topCollegesQueryParams = {
  ...baseQueryParams,
  sort: 'display_sequence:asc',
  filters: {
    is_top: { $eq: true },
    country: {
      country_name: { $eqi: 'India' },
    },
  },
  fields: [
    'college_name',
    'college_url',
    'abbreviation',
    // "average_placement",
    'is_top',
    'is_online_college',
  ],
  populate: {
    college_navbars: { fields: ['id', 'title'] },
    logo: { fields: ['id', 'url', 'name'] },
  },
};

export const faqStudyAbroadParams = {
  ...baseQueryParams,
  sort: 'answer:desc',
  fields: ['question', 'answer', 'updatedAt', 'id'],
  filters: {
    geo_countries: { $null: true },
  },
  populate: {
    categories: {
      fields: ['category_name'],
      filters: { is_related_study_abroad: true },
    },
  },
};

export const categoryParams = {
  ...baseQueryParams,
  sort: 'category_sequence:asc',
  fields: ['category_name', 'is_related_study_abroad'],
  filters: {
    is_related_study_abroad: true,
    study_abroad_faqs: {
      count: { $gt: 0 },
    },
  },
};

export const examsQueryParams = {
  ...baseQueryParams,
  sort: 'display_sequence:asc',
  filters: {
    is_top: { $eq: true },
    is_related_study_abroad: { $eq: true },
  },
  fields: ['exam_name', 'abbreviation', 'exam_url', 'application_release_date', 'exam_date', 'result_date'],
  populate: {
    exam_navbars: { fields: ['id', 'title'] },
    logo: { fields: ['id', 'url', 'name'] },
    streams: { fields: ['id', 'stream_name'] },
    country: { fields: ['id', 'country_name', 'country_url'] },
    exam_mode: { fields: ['exam_mode'] },
  },
};

export const topExamsQueryParams = {
  ...baseQueryParams,
  sort: 'display_sequence:asc',
  filters: {
    is_top: { $eq: true },
  },
  fields: [
    'exam_name',
    'abbreviation',
    'exam_url',
    'is_top',
    // "application_release_date",
    // "exam_date",
    // "result_date",
  ],
  populate: {
    exam_navbars: { fields: ['id', 'title'] },
    logo: { fields: ['id', 'url', 'name'] },
  },
};

export const examsQueryParamsExamPage = {
  populate: {
    logo: { fields: ['name', 'url', 'id'] },
    exam_navbars: { fields: ['id', 'title'] },
    // exam_mode: true,
  },
  fields: ['exam_name', 'abbreviation', 'exam_url', 'is_top', 'is_featured', 'exam_date'],
  publicationState: 'live',
  pagination: {
    page: 1,
    pageSize: 40,
  },
};

export const streamsQueryParamsExamPage = {
  fields: ['stream_name'],
  populate: {
    exams: {
      publicationState: 'live',
      populate: {
        exam_navbars: { fields: ['id', 'title'] },
        exam_mode: true,
        logo: {
          fields: ['name', 'url'],
        },
      },
    },
    publicationState: 'live',
    pagination: {
      page: 1,
      pageSize: 40,
    },
    // articles: true,
  },
};
